function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 34",
  transform: "translate(-1100 -6065)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 25",
  cx: 40,
  cy: 40,
  r: 40,
  transform: "translate(1100 6065)",
  fill: "#ed6a5a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-calendar-times",
  d: "M1154.906 6098.25h-29.812a.846.846 0 01-.844-.844v-2.531a3.376 3.376 0 013.375-3.375H1131v-3.656a.846.846 0 01.844-.844h2.813a.846.846 0 01.844.844v3.656h9v-3.656a.846.846 0 01.843-.844h2.813a.846.846 0 01.844.844v3.656h3.375a3.376 3.376 0 013.374 3.375v2.531a.846.846 0 01-.844.844zm-29.812 2.25h29.812a.846.846 0 01.844.844v18.281a3.376 3.376 0 01-3.375 3.375h-24.75a3.376 3.376 0 01-3.375-3.375v-18.281a.846.846 0 01.844-.844zm18.091 11.25l3.382-3.382a.845.845 0 000-1.2l-1.99-1.99a.845.845 0 00-1.2 0l-3.377 3.387-3.382-3.382a.845.845 0 00-1.2 0l-1.99 1.99a.845.845 0 000 1.2l3.382 3.382-3.377 3.377a.845.845 0 000 1.2l1.99 1.99a.845.845 0 001.2 0l3.382-3.382 3.382 3.382a.845.845 0 001.2 0l1.99-1.99a.845.845 0 000-1.2z",
  fill: "#f9cec8"
}));
var SvgXCalendar = function SvgXCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80"
  }, props), _ref);
};
export default SvgXCalendar;